export default {
  tooltipBuyTitle: 'GTNN Mua: ',
  tooltipBuyNetTitle: 'GTNN Ròng: ',
  foreignBuyNetTitle: 'GTNN Mua Ròng: ',
  tooltipSellTitle: 'GTNN Bán: ',
  tooltipSellNetTitle: 'GTNN Ròng: ',
  foreignSellNetTitle: 'GTNN Bán Ròng: ',
  footerText: 'Giá: x 1,000. Khối lượng: x 1,000. Giá trị: x 1,000,000',
  total_foreign_trading: 'TỔNG GIÁ TRỊ GIAO DỊCH KHỐI NGOẠI',
  billion_vnd: 'Tỷ (VND)',
  millionVnd: 'Triệu (VND)',
  total_foreign_buy_value: 'Tổng GTNN Mua: ',
  total_foreign_sell_value: 'Tổng GTNN Bán: ',
  net_foreign_value: 'Tổng GTNN Ròng: ',
  foreign_buy: 'GTNN Mua',
  foreign_sell: 'GTNN Bán',
  net_foreign: 'GTNN Ròng',
  FOREIGN_NET: 'GTNN ròng',
  FOREIGN_VALUE: 'GTNN',
};
